<template>
  <v-dialog
    v-model="checkoutLinkDialog"
    width="500"
    overlay-color="rgba(39, 50, 64)"
    overlay-opacity="0.6"
    :fullscreen="$vuetify.breakpoint.xs"
    persistent
    :transition="false"
  >
    <v-card>
      <v-card-title
        class="header"
        primary-title
      >
        <b>{{ $t('globals.checkoutLink') }}</b>
      </v-card-title>

      <v-card-text>
        <v-flex
          xs12
          mb-5
        >
          <v-checkbox
            v-model="showRefLinks"
            :label="$t('modules.productDialogs.checkoutDialog.showRefLinkLabel') "
            hide-details
          />
        </v-flex>
        <v-flex
          xs12
          mb-5
        >
          <v-text-field
            :value="storeLink"
            :label="$t('modules.productDialogs.checkoutDialog.storeLinkLabel') "
            readonly
            hide-details
            outlined
          >
            <template v-slot:append>
              <div style="position: relative">
                <v-icon
                  v-clipboard:copy="storeLink"
                  style="cursor:pointer;"
                  @click="copy('storeLink_copied')"
                >
                  mdi-content-copy
                </v-icon>
                <small
                  v-if="storeLink_copied"
                  class="copy-hint"
                >{{ $t('globals.copied') }}</small>
              </div>
            </template>
          </v-text-field>
        </v-flex>
        <v-flex
          xs12
          mb-5
        >
          <v-text-field
            :value="productLink"
            :label="$t('modules.productDialogs.checkoutDialog.productLinkLabel')"
            readonly
            hide-details
            outlined
          >
            <template v-slot:append>
              <div style="position: relative">
                <v-icon
                  v-clipboard:copy="productLink"
                  style="cursor:pointer;"
                  @click="copy('productLink_copied')"
                >
                  mdi-content-copy
                </v-icon>
                <small
                  v-if="productLink_copied"
                  class="copy-hint"
                >{{ $t('globals.copied') }}</small>
              </div>
            </template>
          </v-text-field>
        </v-flex>
        <v-flex
          xs12
          mb-5
        >
          <v-text-field
            :value="storeCheckoutLink"
            :label="$t('modules.productDialogs.checkoutDialog.storeCheckoutLinkLabel')"
            readonly
            hide-details
            outlined
          >
            <template v-slot:append>
              <div style="position: relative">
                <v-icon
                  v-clipboard:copy="storeCheckoutLink"
                  style="cursor:pointer;"
                  @click="copy('storeCheckoutLink_copied')"
                >
                  mdi-content-copy
                </v-icon>
                <small
                  v-if="storeCheckoutLink_copied"
                  class="copy-hint"
                >{{ $t('globals.copied') }}</small>
              </div>
            </template>
          </v-text-field>
        </v-flex>
        <v-flex
          xs12
          mb-5
        >
          <v-text-field
            :value="checkoutLink"
            :label="$t('modules.productDialogs.checkoutDialog.checkoutLinkLabel')"
            readonly
            hide-details
            outlined
          >
            <template v-slot:append>
              <div style="position: relative">
                <v-icon
                  v-clipboard:copy="checkoutLink"
                  style="cursor:pointer;"
                  @click="copy('checkoutLink_copied')"
                >
                  mdi-content-copy
                </v-icon>
                <small
                  v-if="checkoutLink_copied"
                  class="copy-hint"
                >{{ $t('globals.copied') }}</small>
              </div>
            </template>
          </v-text-field>
        </v-flex>
      </v-card-text>
      <v-divider />

      <v-card-actions>
        <v-spacer />
        <v-btn
          text
          @click="checkoutLinkDialog = false"
        >
          <span>{{ $t('globals.closeButton') }}</span>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "CheckoutLinkDialog",
  props: {
    domain: {
      type: String,
      default() {
        return '';
      }
    },
    product: {
      type: Object,
      default() {
        return {};
      }
    },
    showDialog: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showRefLinks: false,
      storeLink_copied: false,
      productLink_copied: false,
      storeCheckoutLink_copied: false,
      checkoutLink_copied: false,
    };
  },
  computed: {
    storeLink() {
      return `https://${this.domain}/store${this.showRefLinks?'?sp=XXXXXXXXXX':''}`;
    },
    productLink() {
      return `https://${this.domain}/store/product/${this.product.id}${this.showRefLinks?'?sp=XXXXXXXXXX':''}`
    },
    storeCheckoutLink() {
      return `https://${this.domain}/store?sc_products=[${this.product.id}]${this.showRefLinks?'&sp=XXXXXXXXXX':''}`
    },
    checkoutLink() {
      return `https://${this.domain}/register${this.showRefLinks?'/XXXXXXXXXX':''}?sc_products=[${this.product.id}]`
    },
    checkoutLinkDialog: {
      get() {
        return this.showDialog;
      },
      set() {
        this.$emit('closeCheckoutLinkDialog', false);
      }
    },
  },
  methods: {
    copy(value) {
      this[value] = true
      setTimeout(()=>{
        this[value] = false
      }, 800)
    },
  }
};
</script>

<style lang="scss" scoped>
.copy-hint {
  padding: 5px;
  background: white;
  position: absolute;
  left: 0;
  top: 0;
  transform: translateX(-100%);
}
</style>
